import React, { useRef } from 'react'
import {
	Carousel,
	Card,
	Avatar,
	Typography,
	Row,
	Col,
	Button,
	Space
} from 'antd'
import {
	RocketOutlined,
	ToolOutlined,
	CodeOutlined,
	UserSwitchOutlined,
	RobotOutlined,
	LeftOutlined,
	RightOutlined
} from '@ant-design/icons'
import { Slide, Fade, Zoom } from 'react-awesome-reveal'
import { translate, useSmartTranslation } from '../../../cls/TranslationContext'
import './ClientStories.css'
import { isMobile } from 'react-device-detect'

const { Title, Paragraph, Text } = Typography

const stories = [
	{
		name: translate('demo.s1.name'),
		role: translate('demo.s1.role'),
		avatar: translate('home.stories.s1.avatar'),
		icon: <RocketOutlined />,
		headline: translate('home.stories.s1.headline'),
		quote: translate('demo.s1.quote')
	},
	{
		name: translate('demo.s2.name'),
		role: translate('demo.s2.role'),
		avatar: translate('demo.s1.avatar'),
		icon: <CodeOutlined />,
		headline: translate('demo.s1.headline'),
		quote: translate('demo.s2.quote')
	},
	{
		name: translate('demo.s3.name'),
		role: translate('demo.s3.role'),
		avatar: translate('demo.s2.avatar'),
		icon: <ToolOutlined />,
		headline: translate('demo.s2.headline'),
		quote: translate('demo.s3.quote')
	},
	{
		name: translate('demo.s4.name'),
		role: translate('demo.s4.role'),
		avatar: translate('demo.s3.avatar'),
		icon: <UserSwitchOutlined />,
		headline: translate('demo.s3.headline'),
		quote: translate('demo.s4.quote')
	},
	{
		name: translate('demo.s5.name'),
		role: translate('demo.s5.role'),
		avatar: translate('demo.s4.avatar'),
		icon: <RobotOutlined />,
		headline: translate('demo.s4.headline'),
		quote: translate('demo.s5.quote')
	},
	{
		name: translate('demo.s6.name'),
		role: translate('demo.s6.role'),
		avatar: translate('demo.s5.avatar'),
		icon: <RocketOutlined />,
		headline: translate('demo.s5.headline'),
		quote: translate('demo.s6.quote')
	},
	{
		name: translate('demo.s7.name'),
		role: translate('demo.s7.role'),
		avatar: translate('demo.s6.avatar'),
		icon: <CodeOutlined />,
		headline: translate('demo.s6.headline'),
		quote: translate('demo.s7.quote')
	},
	{
		name: translate('demo.s8.name'),
		role: translate('demo.s8.role'),
		avatar: translate('demo.s8.avatar'),
		icon: <ToolOutlined />,
		headline: translate('demo.s8.headline'),
		quote: translate('demo.s8.quote')
	},
	{
		name: translate('demo.s9.name'),
		role: translate('demo.s9.role'),
		avatar: translate('demo.s8.avatar'),
		icon: <UserSwitchOutlined />,
		headline: translate('demo.s8.headline'),
		quote: translate('demo.s9.quote')
	}
]

const grouped = []
const chunkSize = isMobile ? 1 : 3
for (let i = 0; i < stories.length; i += chunkSize) {
	grouped.push(stories.slice(i, i + chunkSize))
}

const ClientStories = () => {
	const carouselRef = useRef()
	const { t } = useSmartTranslation()

	return (
		<div className="stories-carousel-wrapper">
			<Slide triggerOnce direction="up" cascade damping={0.2}>
				<Title
					level={2}
					style={
						isMobile
							? {}
							: { textAlign: 'center', marginBottom: 10 }
					}
				>
					{t('home.storiesTitle')}
				</Title>
				<Paragraph
					className="stories-subtitle"
					style={isMobile ? {} : { textAlign: 'center' }}
				>
					{t('home.storiesSubtitle')} —{' '}
					<Text
						style={{
							borderBottom: '1px dotted #4846f4',
							fontWeight: 500
						}}
					>
						{t('home.storiesText')}
					</Text>
					.
				</Paragraph>
			</Slide>
			<div style={{ position: 'relative' }}>
				<div className="carousel-arrow-controls">
					<Button
						shape="circle"
						icon={<LeftOutlined />}
						onClick={() => carouselRef.current.prev()}
					/>
					<Button
						shape="circle"
						icon={<RightOutlined />}
						onClick={() => carouselRef.current.next()}
					/>
				</div>

				<Carousel
					autoplay
					dots={false}
					ref={carouselRef}
					autoplaySpeed={5000}
				>
					{grouped.map((group, i) => (
						<div className="carousel-slide" key={i}>
							<Fade triggerOnce delay={200}>
								<Row gutter={[24, 24]} justify="center">
									{group.map((story, j) => (
										<Col xs={24} sm={12} md={8} key={j}>
											<Zoom triggerOnce delay={j * 100}>
												<Card
													className="story-slide-card"
													variant="bordered"
													hoverable
												>
													<div className="story-slide-header">
														<Avatar
															size={48}
															src={story.avatar}
														/>
														<div>
															<Title
																level={5}
																className="story-slide-name"
															>
																{story.name}
															</Title>
															<Paragraph className="story-slide-role">
																{story.role}
															</Paragraph>
														</div>
													</div>
													{!story.headline.startsWith(
														'demo'
													) && (
														<Space
															style={{
																width: '100%'
															}}
															direction="horizontal"
															size={5}
															align="center"
														>
															<div className="story-icon-box">
																{story.icon}
															</div>
															<strong
																style={{
																	color: '#4846f4'
																}}
															>
																{story.headline}
															</strong>
														</Space>
													)}
													{!story.quote.startsWith(
														'demo'
													) && (
														<Paragraph className="story-slide-quote">
															“{story.quote}”
														</Paragraph>
													)}
												</Card>
											</Zoom>
										</Col>
									))}
								</Row>
							</Fade>
						</div>
					))}
				</Carousel>
			</div>
		</div>
	)
}

export default ClientStories
